export default timestamp => {
  let dateValue = 0;

  if (timestamp) {
    dateValue = new Date(timestamp * 1000);
  }

  return dateValue;
};
